module.exports = __webpack_public_path__ + "static/media/back-arrow.22b62f00.svg";